import React, { Component } from 'react';
import FontIcon             from 'material-ui/FontIcon';
import './../css/App.css';
import PropTypes from 'prop-types';

class FavouriteIcon extends Component
{
    toggleFavourite = (placeId) =>
    {
        if (this.props.place.favourite)
        {
            this.props.unFavourite(placeId);
        }
        else
        {
            this.props.favourite(placeId);
        }
    };

    render = () => {
        let favIcon = (this.props.place.favourite) ? 'favorite' : 'favorite_border';

        return (
            <FontIcon
                onTouchTap={ this.toggleFavourite.bind(this, this.props.place.item) }
                color={ this.props.theme.text }
                style={ { fontSize: '28px', float: 'right', marginLeft: '10px' } }
                className="material-icons tap-event">{ favIcon }</FontIcon>
        );
    }
}

FavouriteIcon.propTypes = {
    place: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default FavouriteIcon;


// WEBPACK FOOTER //
// ./src/components/FavouriteIcon.js